<template>
  <div>
    <div>
      <section-title has-line title="Información General" />
      <div class="row ml-2 mb-5">
        <div class="col">
          <span class="color-secondary-6 font-14 font-weight-normal">
            Vendor Name:
          </span>
          <div class="color-black font-16 font-weight-normal">
            {{ value.vendorName }}
          </div>
        </div>
        <div class="col">
          <span class="color-secondary-6 font-14 font-weight-normal">
            Email ID:
          </span>
          <div class="color-black font-16 font-weight-normal">
            {{ value.vendorEmail }}
          </div>
        </div>
        <div class="col">
          <span class="color-secondary-6 font-14 font-weight-normal">
            Vendor Status:
          </span>
          <div class="color-black font-16 font-weight-normal">
            {{ value.vendorStatus }}
          </div>
        </div>
        <div class="col d-flex">
          <action-button
            :i="`fas fa-redo-alt pr-1`"
            variant="outline-success align-self-center"
            @click="$emit('on-update-vendor')"
          >
            Actualizar Vendor
          </action-button>
        </div>
      </div>
      <div>
        <icon-view
          class="mb-3"
          gradient
          icon="fas fa-map-marker-alt"
          icon-background="#FF7058"
          icon-color="#fff"
          title="Direcciones"
        />
        <div
          v-for="(address, index) in value.addresses"
          :key="`address-item-${index}`"
          class="bg-secondary-13 rounded p-2 row mb-2 ml-1"
        >
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              Address:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ address.addressName }}
            </div>
          </div>
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              City:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ address.city }}
            </div>
          </div>
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              State:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ address.state }}
            </div>
          </div>
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              Zip Code:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ address.zipCode }}
            </div>
          </div>
        </div>
        <custom-result-not-found v-if="value.addresses.length == 0" />
      </div>
      <div class="mt-5">
        <icon-view
          class="mb-3"
          gradient
          icon="fas fa-phone-alt"
          icon-background="#FF7058"
          icon-color="#fff"
          title="Contacto"
        />
        <div
          v-for="(contact, index) in value.contacts"
          :key="`contact-item-${index}`"
          class="bg-secondary-13 rounded p-2 row mb-2 ml-1"
        >
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              Line Number int:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ contact.lineNumber }}
            </div>
          </div>
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              Phone Type:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ contact.phoneType }}
            </div>
          </div>
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              Country Code:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ contact.countryCode }}
            </div>
          </div>
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              Phone:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ contact.phone }}
            </div>
          </div>
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              Extension:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ contact.extension | empty }}
            </div>
          </div>
          <div class="col">
            <span class="color-secondary-6 font-14 font-weight-normal">
              Location Description:
            </span>
            <div class="color-black font-16 font-weight-normal">
              {{ contact.locationDescription | empty }}
            </div>
          </div>
        </div>
        <custom-result-not-found v-if="value.contacts.length == 0" />
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import CustomResultNotFound from 'custom-result-not-found';
import IconView from '@/views/provider/billingHistory/components/IconView.vue';

export default {
  name: 'GeneralInfo',
  components: {
    SectionTitle,
    ActionButton,
    CustomResultNotFound,
    IconView,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
